export default __webpack_public_path__ + "static/media/press.04157440.png";